import React from 'react';
import './App.css';
import VexterLanding from './components/VexterLanding';

function App() {
  return (
    <div className="App">
      <VexterLanding />
    </div>
  );
}

export default App;
